import { Tooltip } from "antd"
import { CheckOutlined } from "@ant-design/icons"
import { useEffect, useState } from "react"

/* HOOK đặt ở đây */
function useLabelColumns() {
    const [cols, setCols] = useState(8)

    useEffect(() => {

        function update() {
            const w = window.innerWidth

            if (w < 640) setCols(3)
            else if (w < 768) setCols(5)
            else if (w < 1024) setCols(6)
            else setCols(8)
        }

        update()

        window.addEventListener("resize", update)
        return () => window.removeEventListener("resize", update)

    }, [])

    return cols
}

/* function chia array */
function chunkArray<T>(arr: T[], size: number): T[][] {
    const result: T[][] = []

    for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size))
    }

    return result
}

/* COMPONENT */
export default function LabelBar({ labels, activeLabels, onToggle }: any) {

    const cols = useLabelColumns()

    const rows = chunkArray(labels, cols).reverse()

    return (
        <div className="border-t">

            {rows.map((row: any[], rowIndex: number) => (

                <div
                    key={rowIndex}
                    className="grid gap-[2px] mb-[2px]"
                    style={{
                        gridTemplateColumns: `repeat(${row.length}, 1fr)`
                    }}
                >

                    {row.map((label: any) => {

                        const active = activeLabels?.includes(label.key)

                        return (
                            <Tooltip title={label.label} key={label.key}>
                                <div
                                    onClick={() => onToggle(label.key, label.id)}
                                    className={`
                                        relative text-center text-[10px] h-[20px] cursor-pointer
                                        flex items-center justify-center gap-[3px] text-white transition-all
                                        ${active ? "font-bold z-10" : "opacity-45 hover:opacity-80"}
                                    `}
                                    style={{
                                        background: label.color,
                                        // Viền nằm bên trong vì chip chỉ cao 20px và cách nhau 2px,
                                        // viền ngoài sẽ đè lên chip bên cạnh
                                        boxShadow: active ? "inset 0 0 0 2px #fff, 0 1px 3px rgba(0,0,0,.35)" : undefined,
                                    }}
                                >
                                    {active && <CheckOutlined className="text-[8px]" />}

                                    {label.label}
                                </div>
                            </Tooltip>
                        )

                    })}

                </div>

            ))}

        </div>
    )
}